<script setup>
import { computed } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import Banner from 'dashboard/components-next/banner/Banner.vue';

const store = useStore();
const { t } = useI18n();

const currentUserAvailability = useMapGetter('getCurrentUserAvailability');
const currentAccountId = useMapGetter('getCurrentAccountId');

const isOffline = computed(() => currentUserAvailability.value === 'offline');
const isBusy = computed(() => currentUserAvailability.value === 'busy');

const showBanner = computed(() => {
  return !!currentAccountId.value && (isOffline.value || isBusy.value);
});

const bannerMessage = computed(() => {
  if (isOffline.value) {
    return t('CONVERSATION.AGENT_OFFLINE_WARNING');
  }
  if (isBusy.value) {
    return t('CONVERSATION.AGENT_BUSY_WARNING');
  }
  return '';
});

const setOnlineStatus = async () => {
  try {
    await store.dispatch('updateAvailability', {
      availability: 'online',
      account_id: currentAccountId.value,
    });
    useAlert(t('CONVERSATION.STATUS_UPDATED_ONLINE'));
  } catch (error) {
    // Ignore error
  }
};
</script>

<template>
  <Banner
    v-if="showBanner"
    color="amber"
    :action-label="t('CONVERSATION.SET_ONLINE_ACTION')"
    class="!rounded-none !justify-between px-4 py-2 bg-amber-500 border-amber-600 text-slate-950 font-medium shadow-sm z-50"
    @action="setOnlineStatus"
  >
    <div class="flex items-center gap-2">
      <span class="i-lucide-alert-triangle size-4 text-slate-950" />
      <span class="text-sm font-semibold text-slate-950">{{
        bannerMessage
      }}</span>
    </div>
  </Banner>
</template>
